import { render, staticRenderFns } from "./CardKPI.vue?vue&type=template&id=92077846&scoped=true"
import script from "./CardKPI.vue?vue&type=script&lang=js"
export * from "./CardKPI.vue?vue&type=script&lang=js"
import style0 from "./CardKPI.vue?vue&type=style&index=0&id=92077846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92077846",
  null
  
)

export default component.exports